import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

const LoginExtraFieldOneComponent = () => {
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];
      if (rapsResult) {
        setDescription(rapsResult.extraDescriptionFieldOne);
      }
    }
  }, [RapsEuropeData]);
  
  return (
    <>
      <div id="join-raps" className="flex-block" dangerouslySetInnerHTML={{ __html: description }}></div>
    </>
  );
};

export default LoginExtraFieldOneComponent;
